// src/hooks/useAutoLogout.js
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SESSION_DURATION = 60 * 60 * 1000; // 1 hora em ms
const WARNING_BEFORE = 2 * 60 * 1000;    // Avisa 2 minutos antes

const useAutoLogout = () => {
  const navigate = useNavigate();
  const logoutTimerRef = useRef(null);
  const warningTimerRef = useRef(null);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const clearTimers = () => {
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
  };

  const scheduleLogout = () => {
    clearTimers();

    const loginTime = parseInt(localStorage.getItem("loginTime"), 10);
    if (!loginTime) {
      logout();
      return;
    }

    const elapsed = Date.now() - loginTime;
    const remaining = SESSION_DURATION - elapsed;

    // Sessão já expirou
    if (remaining <= 0) {
      toast.error("Sessão expirada. Faça login novamente.");
      logout();
      return;
    }

    // Agendar aviso 2 minutos antes de expirar
    const warningIn = remaining - WARNING_BEFORE;
    if (warningIn > 0) {
      warningTimerRef.current = setTimeout(() => {
        toast.warn("⚠️ Sua sessão expirará em 2 minutos!", {
          autoClose: 10000,
        });
      }, warningIn);
    }

    // Agendar logout automático
    logoutTimerRef.current = setTimeout(() => {
      toast.error("Sessão expirada. Faça login novamente.");
      setTimeout(logout, 2000); // pequeno delay para o toast aparecer
    }, remaining);
  };

  useEffect(() => {
    scheduleLogout();

    // Verificar também quando a aba volta a ficar visível
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        scheduleLogout();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimers();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
};

export default useAutoLogout;